export enum LoginResponseType {
    InvalidCredentials = 1,
    ServerError = 2,
    Success = 3,
    NotActivated = 4
}
